module.exports = __webpack_public_path__ + "static/img/map.71c039f1.png";